import { createSelector } from 'reselect';

const getRaceState = (state) => state.race;

export const getRaces = createSelector([getRaceState], ({ races }) => races);
export const getRaceById = (raceId) => createSelector([getRaceState], ({ races }) => races.find((race) => race._id === raceId));
